/* RESPONSIBLE TEAM: team-automation-foundations */
import { attr } from '@ember-data/model';
import { empty } from '@ember/object/computed';
import Fragment from 'ember-data-model-fragments/fragment';

export default Fragment.extend({
  text: attr('string'),
  isEmpty: empty('text'),
});
